// extracted by css-extract-rspack-plugin
export default {"ctrlTextField_disabled":"ctrlTextField_disabled-EG09JD","ctrlTextFieldDisabled":"ctrlTextField_disabled-EG09JD"};